import React from 'react';
import { Pane } from 'evergreen-ui';
import { FaTimes } from 'react-icons/fa';
import { useBagContext } from '../../../../../services/bag';
import classnames from 'classnames';

import SearchInputField from '../../CommonForm/SearchInputField';
import { CrateId } from '@wgt/types';

const BoxIds: React.FC = () => {
  const {
    box: { fields, remove },
  } = useBagContext<{
    box: { fields: CrateId[]; remove(index: number): void };
  }>();

  return (
    <div className="simple-input">
      <div className="d-flex flex-column">
        {fields.map((_, index) => (
          <Pane key={`box-${index}`} className="d-flex">
            <SearchInputField
              className="flex-1"
              label={`Box ID ${index > 0 ? index : ''}`}
              fields={[
                {
                  field: `boxes[${index}].name`,
                  placeholder: 'Identification',
                },
              ]}
            />
            <FaTimes
              onClick={() => remove(index)}
              className={classnames({
                hidden: fields.length === 1,
              })}
            />
          </Pane>
        ))}
      </div>
    </div>
  );
};

export default BoxIds;
